import {Component, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {StatePersistenceService} from '../../service/state.persistence.service';
import {Router} from '@angular/router';
import {BreadcrumbService} from '../../service/breadcrumb.service';
import {BaseComponent} from '../../common/component/base/base.component';
import {Meta, Title} from '@angular/platform-browser';
import {UtilitiesService} from '../../service/utilities.service';
import {ProgressIndicatorService} from '../../@shared';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends BaseComponent {
    showProgress!: boolean;

    constructor(@Inject(DOCUMENT) public override document: Document,
                private title: Title,
                private meta: Meta,
                private utilities: UtilitiesService,
                private state: StatePersistenceService,
                private progress: ProgressIndicatorService,
                router: Router,
                breadcrumbService: BreadcrumbService) {
        super(document, router, breadcrumbService);
        progress.event$.subscribe((value: boolean): void => {
            this.showProgress = value;
        });
    }
}
